import Banner from "./components/Banner";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="min-h-screen">
      <Banner />
      <Footer />
    </div>
  );
}

export default App;
